export default __webpack_public_path__ + "static/media/0329.23bbf5a3.jpg";